import { render } from "./Contact.vue?vue&type=template&id=51815bca&ts=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=51815bca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__